<template>
  <div :style="{ opacity: shouldDim ? 0.35 : 1 }">
    <div
      style="position: absolute; height: 68px;"
      :class="{ selected: showingSlot.selected && !showingSlot.ghostSlot } "
      :style="'left: ' + (showingSlot.left - 4) + 'px; top: ' + (showingSlot.top - 4) + 'px; width: ' + (showingSlot.width + 8) + 'px;'"
    />
    <q-card
      flat
      square
      class="cursor-pointer showing"
      :class="{ preview: showingSlot.preview, planned: (!showingSlot.showing && !showingSlot.ghostSlot), ghost: !!showingSlot.ghostSlot, published: showingSlot.showing && showingSlot.showing.published, dirty: !showingSlot.showing || showingSlot.showing.isDirty }"
      :style="colorStyle + '; left: ' + showingSlot.left + 'px; top: ' + showingSlot.top + 'px; width: ' + showingSlot.width + 'px;'"
      @mousedown="$emit('start-drag', showingSlot)"
      @mouseup="$emit('stop-drag', showingSlot)"
      @dblclick="$emit('double-click', showingSlot.showing)"
    >
      <q-card-section
        :class="{ 'resource-planning': resourcePlanning && !showingSlot.selected }"
        horizontal
        style="pointer-events: none;"
      >
        <img
          v-if="displayPoster"
          class="poster-img"
          :class="showingSlot.showing && showingSlot.showing.published ? 'poster-img-small' : ''"
          :src="showingSlot.bookingWeekMovie.movie && showingSlot.bookingWeekMovie.movie.posterImageSmallUrl"
        >
        <q-card-section class="q-pa-xs overflow-hidden">
          <q-card-section class="q-px-xs q-py-none ellipsis">
            {{ showingSlot.bookingWeekMovie.movie && showingSlot.bookingWeekMovie.movie.name || 'Title ' + showingSlot.titleNumber }}
          </q-card-section>
          <q-card-section
            class="q-px-xs q-py-none ellipsis"
          >
            <q-chip
              size="sm"
              dense
              :style="colorStyleHelper(showingSlot.planElement.color)"
            >
              {{ showingSlot.planElement.name }}
            </q-chip>
            <q-chip
              size="sm"
              dense
              color="primary"
              text-color="white"
            >
              {{ showingSlot.priceCard && showingSlot.priceCard.name }}
            </q-chip>
            <q-chip
              v-if="showingSlot.movieTermDescription"
              size="sm"
              dense
              color="secondary"
              text-color="white"
            >
              {{ showingSlot.movieTermDescription }}
            </q-chip>
            <q-chip
              v-if="showingSlot.showing && showingSlot.showing.overrideSeatChart && showingSlot.showing.customSeatChart"
              size="xs"
              square
            >
              <q-avatar
                icon="event_seat"
                color="red"
                text-color="white"
              />
              {{ showingSlot.showing.customSeatChart.name }}
            </q-chip>
            <showing-badge
              v-for="showingBadge in showingSlot.showingBadges"
              :key="showingBadge.id"
              :showing-badge="showingBadge"
              size="xs"
              outline
            />
            <q-badge
              v-if="showingSlot.showing && showingSlot.showing.isRemote"
              class="q-ml-sm"
              style="border-style: dashed;"
              color="green"
              outline
            >
              {{ showingSlot.showing.predictedAttendance || '0' }}
              <q-tooltip style="pointer-events: all;">
                {{ $t('showing.predictedAttendanceLevel') }}
              </q-tooltip>
            </q-badge>
            <q-badge
              v-if="showingSlot.showing && showingSlot.showing.isRemote"
              class="q-ml-sm"
              color="grey-8"
              outline
            >
              {{ showingSlot.showing.ticketsSold }}
              <q-tooltip style="pointer-events: all;">
                Actual Sales
              </q-tooltip>
            </q-badge>
          </q-card-section>
        </q-card-section>
        <q-icon
          v-if="showingSlot.showing && (showingSlot.showing.isDirty || showingSlot.showing.isLocal)"
          name="save"
          style="position: absolute; top: 3px; right: 3px;"
        >
          <q-tooltip style="pointer-events: all;">
            Not saved
          </q-tooltip>
        </q-icon>
        <q-icon
          v-else-if="showingSlot.showing && (showingSlot.showing.published || showingSlot.showing.ticketsSold > 0)"
          name="lock"
          style="position: absolute; top: 3px; right: 3px;"
          :style="showingSlot.showing.ticketsSold > 0 ? 'color: red;' : 'color: #222;'"
        >
          <q-tooltip style="pointer-events: all;">
            {{ showingSlot.showing.ticketsSold }} ticket{{ showingSlot.showing.ticketsSold === 1 ? '' : 's' }} sold
          </q-tooltip>
        </q-icon>
        <q-icon
          v-else-if="!showingSlot.showing"
          name="crop_free"
          style="position: absolute; top: 3px; right: 3px; color: #222;"
        >
          <q-tooltip style="pointer-events: all;">
            Plan, not yet a showing
          </q-tooltip>
        </q-icon>
        <q-icon
          v-if="showingSlot.showing && showingSlot.showing.private"
          name="visibility_off"
          color="negative"
          style="position: absolute; top: 22px; right: 3px;"
        >
          <q-tooltip>
            This showing is private and will not show up on the website
          </q-tooltip>
        </q-icon>
      </q-card-section>
      <div
        v-if="showTimes"
        class="text-no-wrap ellipsis"
        :class="{ 'text-bold': showingSlot.ghostSlot }"
        style="position: absolute; bottom: -25px; left: -2px; color: #6A6;"
      >
        {{ showingSlot.startTime }}
      </div>

      <div
        v-if="showTimes && (!showingSlot.showing || showingSlot.showing.totalDurationMinutes > 15)"
        class="text-no-wrap ellipsis"
        style="position: absolute; bottom: -25px; right: -2px; color: #A66;"
      >
        {{ showingSlot.endTime }}
      </div>

      <div
        v-if="showTimes"
        style="position: absolute; border-top: solid 1px #777"
        :style="{
          left: -(showingSlot.preStartTimeBufferWidth - 4) + 'px',
          width: showingSlot.preStartTimeBufferWidth - 6 + 'px',
          top: '30px'
        }"
      />
      <div
        v-if="showTimes"
        style="position: absolute; border-left: solid 1px #777"
        :style="{
          left: -(showingSlot.preStartTimeBufferWidth - 4) + 'px',
          top: '25px',
          height: '10px'
        }"
      />

      <div
        v-if="showWhiskers"
        style="position: absolute; border-top: solid 1px #777"
        :style="{
          right: -showingSlot.postShowingBufferWidth + 'px',
          width: showingSlot.postShowingBufferWidth - 2 + 'px',
          top: '30px'
        }"
      />
      <div
        v-if="showWhiskers"
        style="position: absolute; border-left: solid 1px #777"
        :style="{
          right: -showingSlot.postShowingBufferWidth + 'px',
          top: '25px',
          height: '10px'
        }"
      />

      <div
        v-if="highlightStart || showingSlot.ghostSlot"
        class="text-no-wrap ellipsis text-bold"
        style="position: absolute; left: 4px;"
        :style="{
          top: (-showingSlot.top + 1) + 'px',
          color: showingSlot.ghostSlot ? '#111' : '#E22'
        }"
      >
        {{ showingSlot.startTime }}
      </div>

      <div
        v-if="highlightStart"
        style="position: absolute; border-left: dashed 2px #F44; bottom: 0px; left: -3px; height: 3000px;"
      />

      <div
        v-if="showingSlot.ghostSlot"
        style="position: absolute; border-left: dotted 2px #111; bottom: -2000px; left: -3px; height: 4000px;"
      />

      <q-tooltip v-if="!showingSlot.showing && !showingSlot.ghostSlot">
        Planned Showing
      </q-tooltip>
    </q-card>
  </div>
</template>

<script>

import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'

export default {
  name: 'ShowingSlot',
  components: {
    ShowingBadge
  },
  props: {
    showingSlot: {
      type: Object,
      required: false,
      default: null
    },
    displayMode: {
      type: String,
      required: false,
      default: 'poster'
    },
    colorBy: {
      type: String,
      required: false,
      default: 'planElement'
    },
    showTimes: {
      type: Boolean,
      required: false,
      default: false
    },
    showWhiskers: {
      type: Boolean,
      required: false,
      default: false
    },
    resourcePlanning: {
      type: Boolean,
      required: false,
      default: false
    },
    highlightStart: {
      type: Boolean,
      required: false,
      default: false
    },
    dim: {
      type: Boolean,
      required: false,
      default: false
    },
    displayPoster: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['start-drag', 'stop-drag', 'double-click'],
  computed: {
    color () {
      if (this.colorBy === 'planElement') {
        return this.showingSlot.planElement.color
      } else if (this.colorBy === 'movie') {
        return this.showingSlot.movie?.color || '#444'
      } else {
        throw new Error('Unhandled ColorBy type')
      }
    },
    colorStyle () {
      return this.colorStyleHelper(this.color)
    },
    shouldDim () {
      if (this.showingSlot.selected || this.showingSlot.ghostSlot) return false

      return this.dim || this.resourcePlanning
    }
  },
  methods: {
    colorStyleHelper (color) {
      return 'color: ' + color + '; border-color: ' + color + '; background-color: ' + color + '33;'
    }
  }
}

</script>

<style lang="scss" scoped>
  .title-count {
    margin-top: 1px;
    text-align: center;
    width: 23px;
    height: 23px;
    font-size: 15px;
    line-height: 26px;
    border-radius: 100px;
    border: solid 1px;
  }

  .poster-img {
    width: 40px;
    height: 56px;
  }

  .poster-img-small {
    width: 36px;
    height: 52px;
  }

  .showing {
    border: solid 2px;
    position: absolute;
    height: 60px;
    background: white;
    z-index: 4;
  }

  .preview {
    border: dotted 2px !important;
    opacity: 0.4 !important;
  }

  .planned {
    border: dashed 2px;
    opacity: 0.5
  }

  .ghost {
    border: dashed 2px #000;
  }

  .selected {
    border: dashed 2px #000 !important;
  }

  .published {
    // border-style: double;
    border-width: 4px;
  }

  .poster-wrapper {
    width: 40px;
    height: 60px;
    overflow: hidden;
  }

  .dirty:not(.selected) > div {
    opacity: 0.7
  }
</style>
